import { Injectable, Injector } from '@angular/core';
import { City } from '@authority-labs/api-interfaces';
import { Path } from '@authority-labs/enums';
import { ColumnFilter } from '@check-list/app/classes';
import { ChangeType } from '@check-list/app/classes/enums';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { CrudService } from '../../shared/services/crud/crud.service';

@Injectable({
  providedIn: 'root'
})
export class CitiesService extends CrudService<City> {
  cities$: BehaviorSubject<City[]> = new BehaviorSubject([]);
  areasFilters: ColumnFilter[] = [];

  private areas: string[] = [];

  constructor(injector: Injector) {
    super(injector, Path.Cities, City);

    CitiesService.changesEmitter
      .pipe(filter((event) => event.path === Path.Cities))
      .subscribe((event) => {
        if (
          [ChangeType.deleted, ChangeType.edited, ChangeType.created].includes(
            event.action
          )
        ) {
          this.getAll().subscribe();
        }
      });
  }

  getAll(): Observable<City[]> {
    return super.getAll().pipe(
      tap((cities) => {
        this.cities$.next(cities);
      })
    );
  }

  fetchAreas(): Observable<string[]> {
    return this.http.get<string[]>(`${this.api}/areas`).pipe(
      tap((areas) => {
        this.areas = areas;
        this.setAreasFilters(areas);
      })
    );
  }

  getAreas(): string[] {
    return this.areas;
  }

  private setAreasFilters(areas: string[]) {
    this.areasFilters = [
      { label: 'לא הוגדר איזור', value: null },
      ...areas.map((area) => ({
        label: area,
        value: area
      }))
    ];
  }
}
